import { useQuery } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { logPatientWire } from '../debug/logPatientWire';
import { patientsApi } from '../api/patientsApi';

export function usePatientProfile(id: number | null | undefined) {
  return useQuery({
    queryKey: keys.patient.profile(id ?? 0),
    queryFn: async ({ signal }) => {
      const data = await patientsApi.getProfile(id!, { signal });
      logPatientWire(`GET /api/patients/${id}`, data);
      return data;
    },
    enabled: id != null,
    staleTime: 120_000,
  });
}
